import Entity from './entity';
export default class Country extends Entity<string> {
  name: string;
  code: string;
  phoneCode: string;
}
